import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { CellContext } from '@tanstack/react-table';

export interface TariffListNameCellProps
  extends CellContext<TariffModel, TariffModel['name']> {}

export const TariffListNameCell = (
  props: TariffListNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
